import React from 'react';
import styled from 'styled-components';

type Props = React.PropsWithChildren<{
  bg?: string;
  className?: string;
  id?: string;
  scale?: number;
}>;

const Content = styled.div<Props>`
  align-items: start;
  background: ${props => props.bg};
  display: flex;
  flex-direction: column;
  height: auto;
  justify-content: center;
  min-height: 100%;
  overflow: hidden;
  padding: 2rem;
  transform: ${props => (props.scale ? `scale(${props.scale})` : 'none')};
`;

export const SlideContent = ({ children, ...props }: Props) => {
  return <Content {...props}>{children}</Content>;
};